var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "section",
        { staticClass: "catalogue-banner-section" },
        [
          _c("content-creator", {
            staticClass: "header-carousel",
            attrs: {
              settings: _vm.getBlobContents("catalog-list-banner"),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              name: "catalog-list-banner",
              "allowed-widgets":
                "carousel,content-list,content-grid,vimeo-videos",
            },
            on: {
              updateBlob: (data) => _vm.saveBlob("catalog-list-banner", data),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c("product-catalog", {
                    attrs: {
                      filters: _vm.WineCatalogFilters,
                      sorters: _vm.WineCatalogSorters,
                    },
                    model: {
                      value: _vm.settings,
                      callback: function ($$v) {
                        _vm.settings = $$v
                      },
                      expression: "settings",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }